import React from 'react';
import { Form, Input, Button,Icon } from 'antd';
import IndexForm from 'components/IndexForm';
import envcompany from 'envcompany';
import style from './index.less';
import { checkUserName } from 'actions/account';
import { login } from 'actions/accountMiddle';
import {toUrl} from 'utils/tool.js';
import {getRealUrl} from 'utils/request.js';
import InputValidate from 'components/InputValidate';
import Cookies from 'js-cookie';

const FormItem = Form.Item;
// const captchaURL = getRealUrl('/captcha?type=login_captcha&value=');
const captchaURL = getRealUrl('/user');

class Login extends React.Component {

    state = {
        showCaptcha:false,
        captcha:'',
        loading:false,
        isOpenUser:false
    }
    constructor(props){
        super(props);
        this.ValidateInput = InputValidate(Input,props.form);
    }

    getCaptcha(username,type){
        if(type === 101017007){
            return `${captchaURL}/${username}/captcha?ts=${(new Date()).getTime()}`;
        }else if(type === 1009){
            // return captchaURL + username;
        }

    }

    handleSubmit = (e)=>{
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true });

                login(values['username'], values['password'], values['captcha']).then(res => {
                    if(res.accountType === 'new'){
                        this.setState({ errMsg: `Please log in to ${envcompany.baseName.toLowerCase()}.com`});
                    }else{
                        Cookies.set('hasLogin',true,{ expires: 365 });
                        if(res.data.sms_token){
                            this.props.history.push('/verify/'+res.data.sms_token);
                        }else{
                            toUrl('/pages');
                        }
                    }
                }).catch(err=>{
                    err = err.data;
                    if (err.code === 1009 || err.code === 101017007){
                        if (!this.state.showCaptcha){
                            this.setState({ showCaptcha: true, captcha: this.getCaptcha(values['username'],err.code) });
                        }else{
                            this.refresh();
                            this.setState({ errMsg: err.msg});
                        }
                    }else{
                        this.setState({ errMsg: err.msg });
                        if(this.state.showCaptcha){
                            this.refresh();
                        }
                        this.props.form.setFieldsValue({password:''});
                    }
                }).then(()=>{
                    this.setState({loading:false});
                });

            }else {
                let errMsg = '';
                const orgin_error_str = Object.keys(err).sort((a,b)=> a>b).join(',');
                const bothempty_error_str = ['username', 'password'].sort((a,b)=> a>b).join(',');
                if (orgin_error_str.indexOf(bothempty_error_str) > -1) {
                    errMsg = 'Please fill in the username and password';
                }else {
                    for (const key in err) {
                        if (err.hasOwnProperty(key)) {
                            errMsg = err[key].errors[0].message;
                            break;
                        }
                    }
                }
                this.setState({errMsg});
            }


        });
    }
    refresh=()=>{

        this.props.form.validateFields(['username'],(err, values) => {
            if (!err) {
                const username = values['username'];
                //只对老用户刷验证码
                checkUserName(values['username']).then(e=>{
                    let _promise;
                    if(e.data.exist === 2){
                        this.setState({captcha:`${captchaURL}/${username}/captcha?ts=${(new Date()).getTime()}`});
                    }
                    return _promise;
                }).catch(err=>{
                    this.setState({ loading: false});
                });
            }
        });
    }
    userChange=()=>{
        this.setState({showCaptcha:false});
    }

    emitEmpty=()=>{
        this.props.form.setFieldsValue({username:''});
    }

    render() {
        const ValidateInput = this.ValidateInput;
        const { getFieldDecorator,getFieldValue } = this.props.form;
        let captcha;
        if (this.state.showCaptcha){
            captcha = <FormItem help="" style={{marginBottom:20}}>
                {getFieldDecorator('captcha', {
                    rules: [{ required: true, message: 'Please enter the verification code' }],
                })(
                    <Input style={{ width: '68%' }} placeholder="Verification" />
                )}
                <a onClick={this.refresh} style={{ width: '30%', height: '40px', float: 'right' }}><img style={{ width: '100%', height: '100%' }} alt="Verification" src={this.state.captcha} /></a>
            </FormItem>;
        }
        const userName = getFieldValue('username');
        const suffix = userName ? <Icon className={style.close} type="close-circle" onClick={this.emitEmpty} /> : null;

        return (
            <div className={style.login}>
                <IndexForm title={`Welcome to ${envcompany.baseName}`} onSubmit={this.handleSubmit}>
                    <div style={{ position: 'absolute', top: -25, color:'#DA433E'}}>{this.state.errMsg}</div>
                    <FormItem help="" style={{marginBottom:20}}>
                        {getFieldDecorator('username', {
                            rules: [{ required: true, message: 'Please fill in the username' }],
                            validateTrigger: false
                        })(
                            <ValidateInput suffix={suffix} onChange={this.userChange} placeholder="Username" />
                        )}
                    </FormItem>
                    <FormItem help="" style={{marginBottom:20}}>
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: 'Please fill in the password' }],
                            validateTrigger: false
                        })(
                            <ValidateInput type="password" placeholder="Password" />
                        )}
                    </FormItem>
                    {captcha}
                    <FormItem>
                        <Button loading={this.state.loading} type="primary" htmlType="submit">Sign in</Button>
                    </FormItem>
                    {envcompany.showConcatUs && <p className={style.tips}>To get an account, please <a href="/contact-us">contact us</a></p> }
                </IndexForm>
            </div>
        );
    }

}

const WrappedLogin = Form.create()(Login);
export default WrappedLogin;



// WEBPACK FOOTER //
// ./src/pages/Login/index.js